export const enum Role {
    ADMIN = 'ADMIN',
    PUBLISHER = 'PUBLISHER',
}

export interface IUser {
    id: string;
    isActive: boolean;
    isRoot: boolean;
    date: Date;
    email: string;
    first: string;
    last: string;
    passwordUpdated: boolean;
    role: Role;
    company: string;
}

export interface IUserEdit {
    id: string;
    email: string;
    first: string;
    last: string;
    role: Role;
    company: string;
}
